import moment from "moment"
import React, { useEffect, useState } from "react"
import { Col, Input, Label, Modal, Row } from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import DynamicForm from "components/custom/DynamicForm/View/DynamicForm"
import AlternativeConfigFieldViewOnly from "./AlternativeConfigFieldViewOnly"
import DynamicFormViewOnly from "components/custom/DynamicForm/View/ViewOnly/DynamicFormViewOnly"

const GovernanceSectionViewOnly = ({
  alternativeId,
  alternative,
  scenario,
  fieldConfigItems,
  sectionFormId,

  brmLabel,
  advancedPlanningLabel,
  investmentCategoryLabel,
  lbrLabel,
  planningCategoryLabel,
  ldoLabel,
  planningStageLabel,
}) => {
  const currentUser = userService.getLoggedInUser()
  const [userOptions, setUserOptions] = useState([])
  const [leadDeliveryOptions, setLeadDeliveryOptions] = useState([])
  const [workflowOptions, setWorkflowOptions] = useState([])
  const [investmentOptions, setInvestmentOptions] = useState([])
  const [businessCaseOptions, setBusinessCaseOptions] = useState([])
  const [planningOptions, setPlanningOptions] = useState([])
  const [alternativePhases, setAlternativePhases] = useState([])
  const [advancedPlanningOptions, setAdvancedPlanningOptions] = useState([])
  const [cpPhaseOptions, setCpPhaseOptions] = useState([])
  const [isManageModalOpen, setIsManageModalOpen] = useState(false)
  const toggleManageModal = () => setIsManageModalOpen(!isManageModalOpen)
  const [userAlternativeAccess, setUserAlternativeAccess] = useState([])
  const [programs, setPrograms] = useState([])
  const [changeRequestTasks, setChangeRequestTasks] = useState([])

  useEffect(() => {
    if (alternativeId > 0) {
      loadData()
      loadChangeRequestTasks()
    }
  }, [alternativeId])

  const loadChangeRequestTasks = async () => {
    let t = await api.getGeneralTasks(
      1,
      "Alternatives",
      alternativeId,
      currentUser.userID
    )
    setChangeRequestTasks(t)
  }

  const loadData = async () => {
    api.getScenarioList(alternative.scenarioID, "UserList").then(usrs => {
      setUserOptions(usrs)
    })
    api.getScenarioList(alternative.scenarioID, "LDO").then(leads => {
      setLeadDeliveryOptions(leads)
    })
    api
      .getScenarioList(alternative.scenarioID, "WorkflowStatus")
      .then(workflows => {
        setWorkflowOptions(workflows)
      })
    api.getList(currentUser.userID, "CPICPhase").then(cp => {
      setCpPhaseOptions(cp)
    })
    api.getScenarioList(alternative.scenarioID, "AdvancedPlanning").then(ap => {
      setAdvancedPlanningOptions(ap)
    })
    api.getList(currentUser.userID, "BCStatus").then(business => {
      setBusinessCaseOptions(business)
    })
    api
      .getScenarioList(alternative.scenarioID, "PlanningCategory")
      .then(plans => {
        setPlanningOptions(plans)
      })
    // let phs = await api.getList(currentUser.userID, "ProjectPhase")
    // setProjectPhaseOptions(phs)
    api.getPrograms(scenario.enterpriseID).then(p => {
      setPrograms(p)
    })
    api
      .getScenarioList(alternative.scenarioID, "AlternativePhase")
      .then(aph => {
        setAlternativePhases(aph)
      })

    api
      .getScenarioList(alternative.scenarioID, "InvestmentCategory")
      .then(invopt => {
        setInvestmentOptions(invopt)
      })
  }

  const loadUserAlternativeAccess = async () => {
    let data = await api.getUserAlternativeAccessData(
      alternative.scenarioID,
      alternativeId
    )
    setUserAlternativeAccess(data)
  }

  return (
    <React.Fragment>
      <Row>
        <Col md="5">
          <div>
            <h5>Key Roles</h5>
          </div>
          <div className="mb-3">
            <Label className="form-label">Submitter / Author</Label>
            <p>
              {
                userOptions.find(x => x.listItemID == alternative.createdByID)
                  ?.listItemName
              }
            </p>
          </div>
          <AlternativeConfigFieldViewOnly
            label={lbrLabel}
            value={alternative.leadUserID}
            fieldConfigItems={fieldConfigItems}
            options={userOptions}
            prop={"leadUserID"}
            type="select"
          />

          <AlternativeConfigFieldViewOnly
            label={brmLabel}
            value={alternative.brmUserID}
            fieldConfigItems={fieldConfigItems}
            options={userOptions}
            prop={"brmUserID"}
            type="select"
          />

          <AlternativeConfigFieldViewOnly
            label={ldoLabel}
            value={alternative.leadDeliveryOrganizationID}
            fieldConfigItems={fieldConfigItems}
            options={leadDeliveryOptions}
            prop={"leadDeliveryOrganizationID"}
            type="select"
          />

          <AlternativeConfigFieldViewOnly
            label="Lead Delivery Organization POC"
            value={alternative.deliveryPOCID}
            fieldConfigItems={fieldConfigItems}
            options={userOptions}
            prop={"deliveryPOCID"}
            type="select"
          />

          <div className="mb-3">
            <Label className="form-label">Project Manager</Label>
            <p>
              {
                userOptions.find(x => x.listItemID == alternative.pmUserID)
                  ?.listItemName
              }
            </p>
          </div>

          <AlternativeConfigFieldViewOnly
            label="Business Case Status"
            value={alternative.bcState}
            fieldConfigItems={fieldConfigItems}
            options={businessCaseOptions}
            prop={"bcState"}
            type="select"
          />

          <div>
            <h5>Key Planning Milestones</h5>
          </div>
          <div className="mb-3">
            <Label className="form-label">Project Start</Label>
            <p>
              {new Date(alternative.desiredStart) >
              new Date(1900, 1, 1, 0, 0, 0, 0)
                ? moment(alternative.desiredStart).format("YYYY-MM-DD")
                : ""}
            </p>
          </div>
          <div className="mb-3">
            <Label className="form-label">Requirements Completion</Label>
            <p>
              {new Date(alternative.requirementsDate) >
              new Date(1900, 1, 1, 0, 0, 0, 0)
                ? moment(alternative.requirementsDate).format("YYYY-MM-DD")
                : ""}
            </p>
          </div>
          <div className="mb-3">
            <Label className="form-label">Market Research Completion</Label>
            <p>
              {new Date(alternative.marketResearchDate) >
              new Date(1900, 1, 1, 0, 0, 0, 0)
                ? moment(alternative.marketResearchDate).format("YYYY-MM-DD")
                : ""}
            </p>
          </div>

          <div className="mb-3">
            <Label className="form-label">Procurement Package Completion</Label>
            <p>
              {new Date(alternative.procurementPackageDate) >
              new Date(1900, 1, 1, 0, 0, 0, 0)
                ? moment(alternative.procurementPackageDate).format(
                    "YYYY-MM-DD"
                  )
                : ""}
            </p>
          </div>
          <div className="mb-3">
            <Label className="form-label">Procurement Completion</Label>
            <p>
              {new Date(alternative.procurementDate) >
              new Date(1900, 1, 1, 0, 0, 0, 0)
                ? moment(alternative.procurementDate).format("YYYY-MM-DD")
                : ""}
            </p>
          </div>
          <div className="mb-3">
            <Label className="form-label">Project Finish</Label>
            <p>
              {new Date(alternative.plannedFinish) >
              new Date(1900, 1, 1, 0, 0, 0, 0)
                ? moment(alternative.plannedFinish).format("YYYY-MM-DD")
                : ""}
            </p>
          </div>

          <div className="mb-3">
            <Label className="form-label">Planning Comments</Label>
            <p>{alternative.planningComments}</p>
          </div>
        </Col>
        <Col md="1"></Col>
        <Col md="5">
          <div>
            <h5>For Administrator and BRM Use Only</h5>
          </div>
          <AlternativeConfigFieldViewOnly
            label="Workflow Status"
            value={alternative.workflowStatusID}
            fieldConfigItems={fieldConfigItems}
            options={workflowOptions}
            prop={"workflowStatusID"}
            type="select"
          />

          <AlternativeConfigFieldViewOnly
            label={planningStageLabel}
            value={alternative.alternativePhaseID}
            fieldConfigItems={fieldConfigItems}
            options={alternativePhases}
            prop={"alternativePhaseID"}
            type="select"
          />

          {!alternative.ideaOnly && (
            <div>
              <h5>For Administrator Use Only</h5>
            </div>
          )}
          <div>
            <div className="mb-3">
              <Label className="form-label">
                {alternative.ideaOnly ? "Share " : "Limit "} Access
              </Label>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Input
                  type="checkbox"
                  className="form-check-input"
                  id="limitaccess"
                  defaultChecked={alternative.limitAccess}
                  disabled={true}
                />
              </div>
            </div>

            <AlternativeConfigFieldViewOnly
              label={advancedPlanningLabel}
              value={alternative.advancedPlanningID}
              fieldConfigItems={fieldConfigItems}
              options={advancedPlanningOptions}
              prop={"advancedPlanningID"}
              type="select"
            />

            <AlternativeConfigFieldViewOnly
              label="CPIC Phase"
              value={alternative.cpicPhaseID}
              fieldConfigItems={fieldConfigItems}
              options={cpPhaseOptions}
              prop={"cpicPhaseID"}
              type="select"
            />

            <AlternativeConfigFieldViewOnly
              label={investmentCategoryLabel}
              value={alternative.investmentCategoryID}
              fieldConfigItems={fieldConfigItems}
              options={investmentOptions}
              prop={"investmentCategoryID"}
              type="select"
            />

            <AlternativeConfigFieldViewOnly
              label="Multi-Year"
              value={alternative.multiYear}
              fieldConfigItems={fieldConfigItems}
              prop={"multiYear"}
              type="checkbox"
            />
            <AlternativeConfigFieldViewOnly
              label="Next Review"
              value={alternative.nextReviewDT}
              fieldConfigItems={fieldConfigItems}
              prop={"nextReviewDT"}
              type="datetime"
            />

            <AlternativeConfigFieldViewOnly
              label={planningCategoryLabel}
              value={alternative.projectCategoryID}
              fieldConfigItems={fieldConfigItems}
              options={planningOptions}
              prop={"projectCategoryID"}
              type="select"
            />

            <AlternativeConfigFieldViewOnly
              label="Program"
              value={alternative.programID}
              fieldConfigItems={fieldConfigItems}
              options={programs.map(p => {
                return { listItemID: p.programID, listItemName: p.programName }
              })}
              prop={"programID"}
              type="select"
            />

            <div className="mb-3">
              <Label className="form-label">Program Allocation</Label>
              <p>{alternative.programAllocation}</p>
            </div>

            <div className="mb-3">
              <Label className="form-label">Rating and Score</Label>
              <div
                style={{
                  textAlign: "left",
                  display: "flex",
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
              >
                <div
                  style={{ width: "150px" }}
                  dangerouslySetInnerHTML={{ __html: alternative.ratingPill }}
                ></div>
                <div style={{ width: "150px", fontWeight: "600" }}>
                  {" "}
                  {alternative.saaScore}{" "}
                </div>
              </div>
            </div>

            <AlternativeConfigFieldViewOnly
              label="Exclude from Decision"
              value={alternative.exclude}
              fieldConfigItems={fieldConfigItems}
              prop={"exclude"}
              type="checkbox"
            />

            <AlternativeConfigFieldViewOnly
              label="Completed"
              value={alternative.inactive}
              fieldConfigItems={fieldConfigItems}
              prop={"inactive"}
              type="checkbox"
            />
          </div>

          {currentUser.createRevision && (
            <>
              {alternative.revisionAltID > 0 && (
                <>
                  {changeRequestTasks.length > 0 && (
                    <div className="mb-3">
                      <Label className="form-label">Change Request</Label>
                      <p>
                        {
                          changeRequestTasks.find(
                            x => x.taskID == revisionTaskID
                          )?.taskName
                        }
                      </p>
                      {/* <select
                        className="form-control form-select select2 mb-xxl-0"
                        value={alternative.revisionTaskID}
                        onChange={e => {
                          changeAlternativeProp(
                            "revisionTaskID",
                            e.target.value
                          )
                        }}
                      >
                        <option value="0">NA</option>
                        {changeRequestTasks.map((a, idx) => {
                          return (
                            <option key={idx} value={`${a.taskID}`}>
                              CR-{a.taskNum} {a.taskName}
                            </option>
                          )
                        })}
                      </select> */}
                    </div>
                  )}
                  <div className="mb-3">
                    <Label className="form-label">Revision Description</Label>
                    <p>{alternative.revisionDescription}</p>
                  </div>
                </>
              )}
            </>
          )}
        </Col>
      </Row>

      {sectionFormId != 0 && (
        <>
          <Row>
            <Col md="12">
              <div className="divider"></div>
              <DynamicFormViewOnly
                formId={sectionFormId}
                itemId={alternative?.alternativeID}
                scenarioId={alternative?.scenarioID}
              />
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  )
}

export default GovernanceSectionViewOnly
